<template>
    <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
        </ion-buttons>
        <ion-title>
          Manage Reservation /
          <span class="ion-sub-title">{{reservationId}}</span>
        </ion-title>
        <ion-buttons slot="end" v-if="isCancelPermissionAvailable && reservation && reservation.status.id === 'O'">
          <ion-button @click="openReservationCancel" class="hdrBtn">CANCEL</ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button v-if="this.userRoleId == 1" @click="editReservationUsage" class="hdrBtn">Edit</ion-button>
          <ion-button @click="viewUserDetails" class="hdrBtn">View User Details</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="page">
        <ion-grid fixed v-if="reservation" class="rp-mobile">
          <ion-row
            v-if="reservation.status.id === 'P' || reservation.status.id === 'C'"
            class="row-divider"
          ></ion-row>
          <ion-row
            v-if="reservation.status.id === 'P' || reservation.status.id === 'C'"
            class="rectangle"
          >
            <ion-col>
              <ion-row align-items-stretch>
                <ion-col size="6" class="col-padding">
                </ion-col>
                <ion-col size="6" class="col-padding">
                  <ion-button
                    v-if="reservation.status.id === 'P' || reservation.status.id === 'C'"
                    class="btn-secondary"
                    expand="block"
                    @click="viewCharging"
                  >View Status</ion-button>
                </ion-col>
              </ion-row>
              
            </ion-col>
          </ion-row>
          
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle">
            <ion-col>
              <ion-row align-items-stretch>
                <ion-col size="6" class="col-padding">
                  <span class="reservation-head">
                    <img
                      v-if="reservation.vehicle.type.id === 'TW'"
                      class="vh-icon"
                      src="/assets/images/vehicles/335024.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'FW'"
                      class="vh-icon"
                      src="/assets/images/vehicles/846338.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == '3W'"
                      class="vh-icon"
                      src="/assets/images/vehicles/rickshaw.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'BUS'"
                      class="vh-icon"
                      src="/assets/images/vehicles/bus.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'TRUCK'"
                      class="vh-icon"
                      src="/assets/images/vehicles/truck.png"
                    />
                    &nbsp;&nbsp;
                    {{reservation.vehicle.regNo}}
                  </span>
                  <br />
                  <ion-label
                    class="reservation-desc"
                  >{{reservation.vehicle.make.name}}&nbsp;{{reservation.vehicle.model.name}}</ion-label>
                  <br />
                  <ion-label class="reservation-desc">{{reservation.vehicle.socketType.name}}</ion-label>
                </ion-col>
                <ion-col size="6" class="col-padding" text-right>
                  <ion-label class="book-time">
                    {{changeDateFormatWithTime(reservation.slot.startsOn)}}
                    <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
                    <!-- <br />
                    {{changeDateFormatWithTime(reservation.slot.endsOn)}} -->
                  </ion-label>
                  <br />
                  <ion-label
                    v-if="reservation.status.id !== 'C'"
                    class="reservation-desc"
                  >Reservation time</ion-label>
                  <ion-label v-else class="reservation-desc">Reservation time</ion-label>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle">
            <ion-col>
              <ion-row align-items-stretch>
                <ion-col size="12" class="col-padding">
                  <ion-label class="book-station">{{reservation.station.name}}</ion-label>
                  <br />
                  <ion-label
                    class="reservation-desc"
                  >{{reservation.station.address.line1}}, {{reservation.station.address.city}}</ion-label>
                  <br />
                  <br />
                  <ion-label class="section-desc">
                    {{reservation.station.address.line1}},
                    {{reservation.station.address.line2}}
                    <br />
                    {{reservation.station.address.line3}},
                    {{reservation.station.address.city}}
                    <br />
                    {{reservation.station.address.state.name}} -
                    {{reservation.station.address.zipcode}}
                  </ion-label>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                  <ion-label class="section-head">Customer</ion-label>
                  <br />
                  <ion-label class="section-desc">
                    Name :
                    <a
                      class="ext-link"
                      @click="viewProfile(reservation.customer.profile.userId)"
                    >{{reservation.customer.profile.firstName}} {{reservation.customer.profile.lastName}}</a>
                  </ion-label>
                  <br />
                  <ion-label class="section-desc">
                    Contact :
                    <a
                      v-bind:href="'tel:' + reservation.customer.profile.mobile"
                    >{{reservation.customer.profile.mobile}}</a>
                  </ion-label>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" class="col-padding">
              <ion-label class="section-head">Charger</ion-label>
              <br />
              <ion-label class="section-desc">Charger ID : {{ reservation.gun.setup.charger.id }}</ion-label>
              <br />
              <ion-label class="section-desc">Charger Type : {{getTitle(reservation.gun.title)}}</ion-label>
              <!-- <br />
              <ion-label class="section-desc">Charger Output : {{reservation.gun.subTitle}}</ion-label> -->
              <br />
              <ion-label class="section-desc">Charging Port : {{reservation.gun.detail}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" class="col-padding">
              <ion-label class="section-head">Reservation</ion-label>
              <br />
              <ion-label class="section-desc">Reservation # : {{reservation ? reservation.refNo : ''}}</ion-label>
              <br />
              <ion-label class="section-desc">Reservation Type : {{reservation.type.info.name}}</ion-label>
              <ion-label
                      v-if="reservation.type.code == 'CB'"
                      class="section-desc"
                    ><br />Battery capacity at the time of reservation : {{reservation.existingQuantity}}</ion-label>
                  <ion-label
                      v-if="reservation.type.code == 'AB' && parseInt(reservation.commercial.estimated.nettCost) != 0"
                      class="section-desc"
                    ><br />Amount To Charge : &#8377;{{reservation.amountToCharge.toFixed(2)}}</ion-label>
                  <ion-label
                      v-if="reservation.type.code == 'UB'"
                      class="section-desc"
                    ><br />Unit To Charge : {{reservation.unitToCharge.toFixed(3)}}</ion-label>
                  <br />
              <ion-label class="section-desc">Bay Name/Connector :</ion-label>
              <ion-label class="status-medium-rc bay-connector">{{reservation.bayName}}</ion-label>-
              <ion-label class="status-medium-rc bay-connector">{{reservation.portName}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="6" class="col-padding" text-left>
              <ion-label class="section-head">Status</ion-label>
              <br />
              <ion-label
                v-if="reservation.status.id === 'NA'"
                class="book-amount"
              >&#8377; {{reservation.commercial.estimated.nettCost | currency}}</ion-label>
              <br />
              <ion-label
                :key="reservation.status.id"
                v-bind:class="statusClass"
              >{{reservation.status.name}}</ion-label>
            </ion-col>
            <ion-col  size="6"  class="col-padding" text-left v-if="reservation.cmsAdditionalMessage">
              <ion-label class="section-head">Reason Code</ion-label>
              <br />
              <ion-label class="section-desc">{{reservation.cmsAdditionalMessage}}</ion-label>
              <br />
              <ion-label class="section-desc" v-if="reservation.otherError != null">{{reservation.otherError}}</ion-label>
              
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" size-md="4" class="col-padding">
              <ion-label class="section-head">Estimation Details</ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Start Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.estimated.slot.startsOn)}}
              </ion-label>
              <!-- below code is commented on 05-11-2025, As per siva sir request end time is not displaying -->
              <!-- <br />
              <ion-label class="section-desc">
                <b>End Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.estimated.slot.endsOn)}}
              </ion-label> -->
              <br />
              <ion-label class="section-desc">
                <b>Estimated kWh :</b>
                {{reservation.commercial.estimated.unit.toFixed(3)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Usage Charge :</b>
                &#8377;{{reservation.commercial.estimated.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Distribution Charge :</b>
                &#8377;{{(reservation.commercial.estimated.distributionCharge ? reservation.commercial.estimated.distributionCharge : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Discount % :</b>
                {{reservation.commercial.estimated.discountPercentage ? reservation.commercial.estimated.discountPercentage : 0}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Discount :</b>
                &#8377;{{(reservation.commercial.estimated.discountAmount ? reservation.commercial.estimated.discountAmount : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Taxable Amount :</b>
                &#8377;{{reservation.commercial.estimated.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Total Tax :</b>
                &#8377;{{reservation.commercial.estimated.gstamount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Invoice Total :</b>
                &#8377;{{reservation.commercial.estimated.nettCost.toFixed(2)}}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row v-if="reservation.status.id === 'C'" class="row-divider"></ion-row>
          <ion-row v-if="reservation.status.id === 'C'" class="rectangle" align-items-stretch>
            <ion-col size="12" size-md="4" class="col-padding">
              <ion-label class="section-head">
                Invoice Details &nbsp;&nbsp;
                <ion-button class="btn-download" @click="downloadInvoice">
                  <ion-icon :icon="download"></ion-icon>Download
                </ion-button>
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Start Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.actual.slot.startsOn)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>End Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.actual.slot.endsOn)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Time Completed :</b>
                {{reservation.timeCompleted}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Actual kWh :</b>
                {{(reservation.commercial.actual.unit ? reservation.commercial.actual.unit : 0).toFixed(3)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Usage Charge :</b>
                &#8377;{{reservation.commercial.actual.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Distribution Charge :</b>
                &#8377;{{(reservation.commercial.actual.distributionCharge ? reservation.commercial.actual.distributionCharge : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Discount % :</b>
                {{reservation.commercial.actual.discountPercentage ? reservation.commercial.actual.discountPercentage : 0}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Discount :</b>
                &#8377;{{(reservation.commercial.actual.discountAmount ? reservation.commercial.actual.discountAmount : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Taxable Amount :</b>
                &#8377;{{reservation.commercial.actual.taxableAmount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Total Tax :</b>
                &#8377;{{reservation.commercial.actual.gstamount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice Total :</b>
                &#8377;{{reservation.commercial.actual.nettCost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice No :</b>
                {{reservation.invoice.invoiceNo}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice Date :</b>
                {{changeDateFormatWithoutTime(reservation.invoice.invoiceOn)}}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row v-if="reservation.status.id === 'C'" class="row-divider"></ion-row>
          <ion-row v-if="reservation.status.id === 'C'" class="rectangle" align-items-stretch>
            <ion-col size="12" class="col-padding">
              <ion-label class="section-head">Usage Details</ion-label>
              <br />
              <ion-row>
                <ion-col>
                  <ion-label class="section-head">ToU</ion-label>
                </ion-col>
                <ion-col>
                  <ion-label class="section-head">Tariff</ion-label>
                </ion-col>
                <ion-col class="numeric-desc">
                  <ion-label class="section-head">Usage</ion-label>
                </ion-col>
                <ion-col class="numeric-desc">
                  <ion-label class="section-head">Rs/kWh</ion-label>
                </ion-col>
                <ion-col class="numeric-desc">
                  <ion-label class="section-head">Charges</ion-label>
                </ion-col>
              </ion-row>
              <ion-row
                class="list-item"
                v-for="(invoiceTariff, index) in this.reservation.invoiceDetails"
                :key="index"
              >
                <ion-col class="section-desc">{{invoiceTariff.tariffTag}}</ion-col>
                <ion-col class="section-desc">{{invoiceTariff.tariffCode}}</ion-col>
                <ion-col class="numeric-desc">{{invoiceTariff.unitsConsumed.toFixed(3)}}</ion-col>
                <ion-col class="numeric-desc">{{invoiceTariff.unitPrice.toFixed(2)}}</ion-col>
                <ion-col class="numeric-desc">{{invoiceTariff.usageCost.toFixed(2)}}</ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row v-if="reservation.status.id === 'C'" class="rectangle" align-items-stretch>
            <ion-col size="12" class="col-padding">
              <ion-label class="section-head">Meter Reads</ion-label>
              <br />
              <ion-row>
                <ion-col>
                  <ion-label class="section-head">ToU</ion-label>
                </ion-col>
                <ion-col>
                  <ion-label class="section-head">Tariff</ion-label>
                </ion-col>
                <ion-col class="numeric-desc">
                  <ion-label class="section-head">Usage</ion-label>
                </ion-col>
                <ion-col class="numeric-desc">
                  <ion-label class="section-head">Rs/kWh</ion-label>
                </ion-col>
                <ion-col class="numeric-desc">
                  <ion-label class="section-head">Charges</ion-label>
                </ion-col>
              </ion-row>
              <ion-row
                class="list-item"
                v-for="(invoiceTariff, index) in this.reservation.invoiceDetails"
                :key="index"
              >
                <ion-col class="section-desc">{{invoiceTariff.tariffTag}}</ion-col>
                <ion-col class="section-desc">{{invoiceTariff.tariffCode}}</ion-col>
                <ion-col class="numeric-desc">{{invoiceTariff.unitsConsumed.toFixed(3)}}</ion-col>
                <ion-col class="numeric-desc">{{invoiceTariff.unitPrice.toFixed(2)}}</ion-col>
                <ion-col class="numeric-desc">{{invoiceTariff.usageCost.toFixed(2)}}</ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          
        </ion-grid>

        <ion-grid fixed v-if="reservation" class="rp-desktop">
          <ion-row class="rectangle">
            <ion-col>
              <ion-row align-items-stretch>
                <ion-col size="12" size-md="3" class="col-padding">
                  <ion-label class="book-station">{{reservation.station.name}}</ion-label>
                  <br />
                  <ion-label
                    class="reservation-desc"
                  >{{reservation.station.address.line1}}, {{reservation.station.address.city}}</ion-label>
                  <br />
                  <br />
                  <ion-label class="section-desc">
                    {{reservation.station.address.line1}},
                    {{reservation.station.address.line2}}
                    <br />
                    {{reservation.station.address.line3}},
                    {{reservation.station.address.city}}
                    <br />
                    {{reservation.station.address.state.name}} -
                    {{reservation.station.address.zipcode}}
                  </ion-label>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                  <span class="reservation-head">
                    <img
                      v-if="reservation.vehicle.type.id === 'TW'"
                      class="vh-icon"
                      src="/assets/images/vehicles/335024.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'FW'"
                      class="vh-icon"
                      src="/assets/images/vehicles/846338.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == '3W'"
                      class="vh-icon"
                      src="/assets/images/vehicles/rickshaw.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'BUS'"
                      class="vh-icon"
                      src="/assets/images/vehicles/bus.png"
                    />
                    <img
                      v-if="reservation.vehicle.type.id == 'TRUCK'"
                      class="vh-icon"
                      src="/assets/images/vehicles/truck.png"
                    />
                    &nbsp;&nbsp;
                    {{reservation.vehicle.regNo}}
                  </span>
                  <br />
                  <ion-label
                    class="reservation-desc"
                  >{{reservation.vehicle.make.name}}&nbsp;{{reservation.vehicle.model.name}}</ion-label>
                  <br />
                  <ion-label class="reservation-desc">{{reservation.vehicle.socketType.name}}</ion-label>
                  <br />
                  <ion-button
                    v-if="reservation.status.id === 'O' && reservation.isTimeForCharging"
                    class="btn-primary"
                    expand="block"
                    @click="startCharging"
                    :disabled = startBtnInd
                  >Start Charging</ion-button>
                  
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                  <ion-label class="book-time">
                    {{changeDateFormatWithTime(reservation.slot.startsOn)}}
                    <!-- below code is commented on 09-05-2025, As per siva sir request end time is not displaying -->
                    <!-- <br />
                    {{changeDateFormatWithTime(reservation.slot.endsOn)}} -->
                  </ion-label>
                  <br />
                  <ion-label
                    v-if="reservation.status.id !== 'C'"
                    class="reservation-desc"
                  >Reservation time</ion-label>
                  <ion-label v-else class="reservation-desc">Reservation time</ion-label>
                  <br />
                  <br />
                  <br />
                  <ion-button
                    v-if="reservation.status.id === 'P'"
                    class="btn-critical"
                    expand="block"
                    @click="stopChargingAlert"
                    :disabled = startBtnInd
                  >Stop Charging</ion-button>
                </ion-col>
                
                <ion-col size="12" size-md="3" class="col-padding">
                  <ion-label class="section-head">Customer</ion-label>
                  <br />
                  <ion-label class="section-desc">
                    Name :
                    <a
                      class="ext-link"
                      @click="viewProfile(reservation.customer.profile.userId)"
                    >{{reservation.customer.profile.firstName}} {{reservation.customer.profile.lastName}}</a>
                  </ion-label>
                  <br />
                  <ion-label class="section-desc">
                    Contact :
                    <a
                      v-bind:href="'tel:' + reservation.customer.profile.mobile"
                    >{{reservation.customer.profile.mobile}}</a>
                  </ion-label>
                  <br><br>
                  <ion-button
                    v-if="reservation.status.id === 'P' || reservation.status.id === 'C'"
                    class="btn-secondary"
                    expand="block"
                    @click="viewCharging"
                  >View Status</ion-button>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" size-md="3.5" class="col-padding">
              <ion-label class="section-head">Charger</ion-label>
              <br />
              <ion-label class="section-desc">Charger ID : {{ reservation.gun.setup.charger.id }}</ion-label>
              <br/>
              <ion-label class="section-desc">Charger Type : {{getTitle(reservation.gun.title)}}</ion-label>
              <!-- <br />
              <ion-label class="section-desc">Charger Output : {{reservation.gun.subTitle}}</ion-label> -->
              <br />
              <ion-label class="section-desc">Charging Port : {{reservation.gun.detail}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="3.5" class="col-padding">
              <ion-label class="section-head">Reservation</ion-label>
              <br />
              <ion-label class="section-desc">Reservation # : {{reservation ? reservation.refNo : ''}}</ion-label>
              <br />
              <ion-label class="section-desc">Reservation Type : {{reservation.type.info.name}}</ion-label>
              <ion-label
                  v-if="reservation.type.code == 'CB'"
                  class="section-desc"
                ><br />Battery capacity at the time of reservation : {{reservation.existingQuantity}}</ion-label>
              <ion-label
                  v-if="reservation.type.code == 'AB' && parseInt(reservation.commercial.estimated.nettCost) != 0"
                  class="section-desc"
                ><br />Amount To Charge : &#8377;{{reservation.amountToCharge.toFixed(2)}}</ion-label>
              <ion-label
                  v-if="reservation.type.code == 'UB'"
                  class="section-desc"
                ><br />Unit To Charge : {{reservation.unitToCharge.toFixed(3)}}</ion-label>
              <br />
              <ion-label class="section-desc">Output Name/Port Name : </ion-label>
              <ion-label class="status-medium-rc bay-connector">{{reservation.bayName}}</ion-label>-
              <ion-label class="status-medium-rc bay-connector">{{reservation.portName}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2.5" class="col-padding" text-left>
              <ion-label class="section-head">Status</ion-label>
              <br />
              <ion-label
                v-if="reservation.status.id === 'NA'"
                class="book-amount"
              >&#8377; {{reservation.commercial.estimated.nettCost | currency}}</ion-label>
              <br />
              
              <ion-label
                :key="reservation.status.id"
                v-bind:class="statusClass"
              >{{reservation.status.name}}</ion-label><br><br>
            </ion-col>
            <ion-col  size="12" size-md="2.5" class="col-padding" text-left v-if="reservation.cmsAdditionalMessage">
              <ion-label class="section-head">Reason Code</ion-label>
              <br />
              <ion-label class="section-desc">{{reservation.cmsAdditionalMessage}}</ion-label>
              <br />
              <ion-label class="section-desc" v-if="reservation.otherError != null">{{reservation.otherError}}</ion-label>
              
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle" align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-head">Estimation Details</ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Start Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.estimated.slot.startsOn)}}
              </ion-label>
              <!-- below code is commented on 21-05-2025, As per siva sir request end time is not displaying -->
              <!-- <br />
              <ion-label class="section-desc">
                <b>End Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.estimated.slot.endsOn)}}
              </ion-label> -->
              <br />
              <ion-label class="section-desc">
                <b>Estimated kWh :</b>
                {{reservation.commercial.estimated.unit.toFixed(3)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Usage Charge :</b>
                &#8377;{{reservation.commercial.estimated.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Distribution Charge :</b>
                &#8377;{{(reservation.commercial.estimated.distributionCharge ? reservation.commercial.estimated.distributionCharge : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Discount % :</b>
                {{reservation.commercial.estimated.discountPercentage ? reservation.commercial.estimated.discountPercentage : 0}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Discount :</b>
                &#8377;{{(reservation.commercial.estimated.discountAmount ? reservation.commercial.estimated.discountAmount : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Taxable Amount :</b>
                &#8377;{{reservation.commercial.estimated.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Total Tax :</b>
                &#8377;{{reservation.commercial.estimated.gstamount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Estimated Invoice Total :</b>
                &#8377;{{reservation.commercial.estimated.nettCost.toFixed(2)}}
              </ion-label>
            </ion-col>
            <ion-col v-if="reservation.status.id === 'C'" size="12" size-md="3" class="col-padding">
              <ion-label class="section-head">
                Invoice Details &nbsp;&nbsp;
                <ion-button class="btn-download" @click="downloadInvoice">
                  <ion-icon :icon="download"></ion-icon>Download
                </ion-button>
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Start Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.actual.slot.startsOn)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>End Time :</b>
                {{changeDateFormatWithTime(reservation.commercial.actual.slot.endsOn)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Time Completed :</b>
                {{reservation.timeCompleted}}
              </ion-label><br />
              <ion-label class="section-desc">
                <b>Actual kWh :</b>
                {{(reservation.commercial.actual.unit ? reservation.commercial.actual.unit : 0).toFixed(3)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Usage Charge :</b>
                &#8377;{{reservation.commercial.actual.cost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Distribution Charge :</b>
                &#8377;{{(reservation.commercial.actual.distributionCharge ? reservation.commercial.actual.distributionCharge : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Discount % :</b>
                {{reservation.commercial.actual.discountPercentage ? reservation.commercial.actual.discountPercentage : 0}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Discount :</b>
                &#8377;{{(reservation.commercial.actual.discountAmount ? reservation.commercial.actual.discountAmount : 0).toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Taxable Amount :</b>
                &#8377;{{reservation.commercial.actual.taxableAmount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Total Tax :</b>
                &#8377;{{reservation.commercial.actual.gstamount.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice Total :</b>
                &#8377;{{reservation.commercial.actual.nettCost.toFixed(2)}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice No :</b>
                {{reservation.invoice.invoiceNo}}
              </ion-label>
              <br />
              <ion-label class="section-desc">
                <b>Invoice Date :</b>
                {{changeDateFormatWithoutTime(reservation.invoice.invoiceOn)}}
              </ion-label>
            </ion-col>
            <ion-col v-if="reservation.status.id === 'C'" size="12" size-md="6" class="col-padding">
              <ion-row>
                <ion-col>
                  <ion-label class="section-head">Usage Details</ion-label><br/>
                  <ion-row class="list-head">
                    <ion-col size="12" size-md="2">
                      <ion-label class="section-head">ToU</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                      <ion-label class="section-head">Tariff</ion-label>
                    </ion-col>
                    <ion-col class="numeric-desc" size="12" size-md="2">
                      <ion-label class="section-head">Usage</ion-label>
                    </ion-col>
                    <ion-col class="numeric-desc" size="12" size-md="2">
                      <ion-label class="section-head">Rs/kWh</ion-label>
                    </ion-col>
                    <ion-col class="numeric-desc" size="12" size-md="2">
                      <ion-label class="section-head">Charges</ion-label>
                    </ion-col>
                  </ion-row>
                  <hr />
                  <ion-row
                    class="list-item"
                    v-for="(invoiceTariff, index) in this.reservation.invoiceDetails"
                    :key="index"
                  >
                    <ion-col size="12" size-md="2">
                      <ion-label class="section-desc">{{invoiceTariff.tariffTag}}</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                      <ion-label class="section-desc">{{invoiceTariff.tariffCode}}</ion-label>
                    </ion-col>
                    <ion-col class="numeric-desc" size="12" size-md="2">
                      <ion-label class="numeric-desc">{{invoiceTariff.unitsConsumed.toFixed(3)}}</ion-label>
                    </ion-col>
                    <ion-col class="numeric-desc" size="12" size-md="2">
                      <ion-label class="numeric-desc">{{invoiceTariff.unitPrice.toFixed(2)}}</ion-label>
                    </ion-col>
                    <ion-col class="numeric-desc" size="12" size-md="2">
                      <ion-label class="numeric-desc">{{invoiceTariff.usageCost.toFixed(2)}}</ion-label>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row><br/>
              <ion-row>
                <ion-col>
                  <ion-label class="section-head">Meter Reads</ion-label><br/>
                  <ion-row class="list-head">
                    <ion-col size="12" size-md="3">
                      <ion-label class="section-head">Start Meter</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="3">
                      <ion-label class="section-head">End Meter</ion-label>
                    </ion-col>
                  </ion-row>
                  <hr />
                  <ion-row class="list-item">
                    <ion-col size="12" size-md="3">
                      <ion-label class="section-desc">{{reservation.startEndMeterDetails.startMeter}}</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="3">
                      <ion-label class="section-desc">{{ reservation.startEndMeterDetails.endMeter }}</ion-label>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </ion-grid>
        <div class="spinner">
          <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
      </div>
    </ion-content>
  </div>
</template>

<script>
import ReservationCancellationModal from "../customer/ReservationCancellationModal.vue";
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { AppUtils } from "@/util/app-utils"
import { download } from 'ionicons/icons';
import { alertController, IonBackButton, IonButton, IonButtons, IonCol, IonGrid, IonHeader, IonIcon, IonLabel, IonRow, IonSpinner, IonTitle, IonToolbar, modalController } from '@ionic/vue';
import { defineComponent } from "vue";
import moment from "moment";

// import { download } from 'ionicons/icons';

export default defineComponent({
  name:  'reservationDetail',
  components: {
    IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonButton, IonGrid, IonRow, IonCol, IonLabel, IonIcon, IonSpinner, modalController
  },
  data() {
    return {
      download,
      viewmode: false,
      loaderTab: true,
      reservationId: "New",
      reservation: null,
      isCancelPermissionAvailable : false,      
      startBtnInd: false,
      userRoleId: ''
    }
  },
  async mounted() {
    this.userRoleId = window.localStorage.getItem("user.roleId");
    localStorage.removeItem("fromManageEdit");
    localStorage.removeItem("mobileOrMail");
    localStorage.removeItem("selecteduser");
      this.isCancelPermissionAvailable = new AppUtils().getUserAccess("10|D");
      let userRole = localStorage.getItem('user.roleId');
      if(userRole == 4) {
        this.isCancelPermissionAvailable = new AppUtils().getUserAccess("130|L");
      }
      
      if (this.$route.params.reservationId) {
      if (this.$route.query.mode) {
        this.viewmode = false;
        this.reservationId = "Edit";
      } else {
        this.viewmode = true;
        this.reservationId = "Detail";

        this.getBooking();
        
        // this.reservation = await new EVCStationReservationService().reservationWithId(
        //   this.$route.params.reservationId
        // );
        // this.loaderTab = false;
      }
      }
  },
  computed: {
    statusClass() {
      var status = 'open';
      if (this.reservation.status.id === 'O') {
        status = 'open';
      } else if (this.reservation.status.id === 'X') {
        status = 'cancelled';
      } else if (this.reservation.status.id === 'P') {
        status = 'wip';
      } else if (this.reservation.status.id === 'I') {
        status = 'ierr';
      } else if (this.reservation.status.id === 'E') {
        status = 'expired';
      } else if (this.reservation.status.id === 'C') {
        status = 'completed';
      } else {
        status = 'open';
      }
      return 'status-medium-rc ' + status;
    }
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    changeDateFormatWithTime(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    changeDateFormatWithoutTime(dateValue) {
      
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
      
    },
    getTitle(title) {
      let secondaryTitle = title.split(",")[0];
      return secondaryTitle;
    },
    async getBooking() {
      try {
        this.reservation = await new EVCStationReservationService().reservationWithId(
        this.$route.params.reservationId
      );
      this.loaderTab = false;
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    editReservationUsage() {
      localStorage.setItem('editReservationUsage', JSON.stringify(this.reservation))
      this.$router.push({ name: "editReservationUsage" });
    },
    viewUserDetails() {
      try {
        if(this.reservation != null) {
          let manageUserDeatils = {
            mobile: this.reservation.customer.profile.mobile,
            pageNo: 1
          }
          // localStorage.setItem("mobileOrMail",this.reservation.customer.profile.mobile)
          localStorage.setItem("mobileOrMail",JSON.stringify(manageUserDeatils))
          this.$router.push({
            name: "manageUsers"
            // query: {userName: this.reservation.customer.profile.mobile}
            });
        }
        
      } catch(err) {
        alert(err)
      }
      
    },
    editReservation() {
      this.viewmode = false;
      this.reservationId = "Edit";
    },
    async openReservationCancel() {
      // const modal = await this.$ionic.modalController.create({      
      const modal = await modalController.create({
        component: ReservationCancellationModal,
        componentProps: {
          data: {
            content: "New Content",
          },
          propsData: {
            title: "Cancel Reservation",
            bookingId: this.$route.params.reservationId,
          },
          methods: {
            // Migration
            // cancelBooking(reason, otherReason) {
            //   modal.dismiss({ id: reason, others: otherReason });
            // },
            // dismissDialog() {
            //   alert('ondismis')
            //   modal.dismiss();
            // },
          },
        },
        cssClass: "my-custom-class",
      });
      modal.componentProps =  {title: "Cancel Reservation", bookingId: this.$route.params.reservationId};
      modal.cssClass = "my-custom-class"
      modal.onDidDismiss().then((data) => {
        // new Code
        // if() {
          if(data.role != 'backdrop') {
            if(data.data != '') {
              let res = { id: data.data, others: data.role }
              if(res) {
                this.cancelBooking(res);
              }
            }
          }
        // }
        
        // Migration
        // modal.onDidDismiss().then((data) => {
        //   var reason = data["data"]; // Here's your selected data!
        //   if (reason) {
        //     this.cancelBooking(reason);
        //   }
        // });
        
      });
      return await modal.present();
    },
    async cancelBooking(reason) {
      try {
        this.loaderTab = true;
        await new EVCStationReservationService().cancelReservationBySuperUser(
          { id: this.$route.params.reservationId },
          new LocalStorage().user,
          reason
        );
        this.getBooking();
        new ToastUtils().presentToast("Reservation cancelled successfully");
      } catch (error) {
        this.loaderTab = false;
        // let serviceError = tryParseServiceError(error);
        // new ToastUtils().presentToast(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },
    viewProfile(profileId) {
      this.$router.push({
        name: "customerProfileView",
        params: { profileId: profileId },
      });
    },
    viewCharging() {
      localStorage.setItem('reservationTypeInfo', JSON.stringify(this.reservation.type))
      this.$router.push({
        name: "achargingStatusView",
        params: { bookingId: this.$route.params.reservationId },
      });
    },
    downloadInvoice() {
      try {
        //SCMT asked to Change this.$route.params.bookingId, to this.$route.params.bookingId ||  this.$route.params.reservationId and changed by vinoth on 08.12.2020
        const URL = new EVCStationReservationService().getDownloadURL(
          this.$route.params.bookingId ||  this.$route.params.reservationId,
          this.reservation.secretCode,
          new LocalStorage().user
        );
        // download(URL);
        // window.open(encodeURI(URL),"_system","location=yes");
        var a = document.createElement("a");
        a.href = URL;
        a.setAttribute("download", "revc_invoice.pdf");
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    
    async startCharging() {
      this.startBtnInd = true;
      try {
        this.loaderTab = true;
        await this.getBooking();
        if(this.reservation.status.id != 'P') {
          let UserId = {id : this.reservation.customer.profile.userId}
          await new EVCStationReservationService().startChargingReservationByUser(
            { id: this.$route.params.reservationId },
            UserId
          );
          localStorage.setItem("dataTransfer", this.reservation.gun.setup.charger.sendDataTransfer)
          if(this.reservation.gun.setup.charger.sendDataTransfer != 'N') {
            new ToastUtils().presentToast(
              "Please check the Charger Control Panel for OTP"
            );
          } else {
            new ToastUtils().presentToast(
              "OTP sent to user mobile number"
            );
          }
          this.$router.push({
            name: "verifyStartCharging",
            params: { bookingId: this.$route.params.reservationId },
          }); 
        }
      } catch (error) {
        this.startBtnInd = false;
        // let serviceError = tryParseServiceError(error);
        // new ToastUtils().presentToast(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      this.loaderTab = false;
    },
    async stopChargingAlert() {
      return alertController.create({
        header: "Stop Charging?",
        message: "Are you sure you want to Stop this Charging?",
        buttons: [
          {
            text: "NO",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {

            }
          },
          {
              text: "YES",
              handler: () => {
              this.stopCharging();
            }
          }
        ]
      }).then(res => res.present());  

      // SCMT 2.O Mifration

      // const alert = document.createElement("ion-alert");
      // alert.header = "Stop Charging?";
      // alert.message = "Are you sure you want to Stop this Charging?";
      // alert.buttons = [
      //   {
      //     text: "NO",
      //     role: "cancel",
      //     cssClass: "secondary",
      //     handler: () => {
      //       console.log("Confirm Cancel");
      //     },
      //   },
      //   {
      //     text: "YES",
      //     handler: () => {
      //       this.stopCharging();
      //     },
      //   },
      // ];

      // document.body.appendChild(alert);
      // return alert.present();
    },
    async stopCharging() {
      this.startBtnInd = true;
      try {
        this.loaderTab = true;
        let UserId = {id : this.reservation.customer.profile.userId}
        await new EVCStationReservationService().stopChargingReservationByUser(
          { id: this.$route.params.reservationId },
          UserId
        );
        this.disableStopBtn = false;
        new ToastUtils().presentToast("Charging stopped successfully");
        this.getBooking();
      } catch (error) {
        this.startBtnInd = false;
        // let serviceError = tryParseServiceError(error);
        // new ToastUtils().presentToast(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      this.loaderTab = false;
    },
  },
})
</script>

<style scoped>
.vh-icon {
  height: 17px;
  width: 33px;
  vertical-align: middle;
  display: inline-block;
  clear: left;
}
.section-desc {
  text-align: left;
  font-family: "Roboto";
  font-size: 13px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
}
.section-answer {
  text-align: right;
  font-family: "Roboto";
  font-size: 13px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
}
.book-amount {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 15px;
  color: #21b24b;
  opacity: 1;
}
.book-day {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}
.book-time {
  text-align: right;
  font-family: "Roboto";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}
.book-station {
  text-align: left;
  font-family: "Roboto Bold";
  font-size: 14px;
  letter-spacing: 0;
  color: #21315d;
  opacity: 1;
}
.reservation-head {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
}
.reservation-desc {
  text-align: left;
  font-family: "Roboto";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 0.5;
}
.station-distance {
  margin: 0px 0px 20px 20px;
  text-align: left;
  font-family: "Roboto";
  font-size: 13px;
  letter-spacing: 0;
  color: #d66c6c;
  opacity: 1;
}
img.call-img {
  width: 24px;
  height: 24px;
  top: -3px;
}
img.map-img {
  width: 36px;
  height: 36px;
  cursor: pointer;
}
.numeric-desc {
  text-align: right !important;
  font-family: "Roboto";
  font-size: 13px;
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
}
.completeReason {
  /* border: 5px solid red; */
  margin-top: 20px;
}
</style>
